import { getPointer } from "libs/schema";
import { ActionServerContext } from "../action";
import { authorizeUserIsMemberOfOrganization } from "./organizationAuthorizers";
import { authorizeUserHasAccessToThread } from "./threadAuthorizers";
import { authorizeUserOwnership } from "./genericAuthorizers";

export async function authorizeUserCanCreateDraft(props: {
  organizationId: string;
  threadId?: string;
  context: ActionServerContext;
}) {
  const { organizationId, threadId, context } = props;

  await Promise.all([
    authorizeUserIsMemberOfOrganization({ organizationId, context }),
    threadId ? authorizeUserHasAccessToThread({ threadId, context }) : null,
  ]);
}

export async function authorizeUserCanUpdateDraft(props: { draftId: string; context: ActionServerContext }) {
  const { draftId, context } = props;

  // We set includeSoftDeletes to true because we only care if the user owns the draft record in question
  await authorizeUserOwnership(getPointer("draft", draftId), context, { includeSoftDeletes: true });
}

export async function authorizeUserCanUpdateDraftEdit(props: { draftEditId: string; context: ActionServerContext }) {
  const { draftEditId, context } = props;

  // We set includeSoftDeletes to true because we only care if the user owns the draft_edit record in question
  await authorizeUserOwnership(getPointer("draft_edit", draftEditId), context, { includeSoftDeletes: true });
}
